import React, { useLayoutEffect, useRef } from 'react';

// Altura máxima antes de a caixa passar a rolar por dentro: um texto muito
// longo não pode empurrar o resto do formulário para fora da tela.
const ALTURA_MAXIMA = 480;

/**
 * Caixa de texto que cresce com o conteúdo, para textos longos como o
 * conteúdo ministrado e a metodologia da aula.
 *
 * Com altura fixa, o texto longo sumia para cima da área visível e parecia
 * que "não cabia" — na verdade o campo não tem limite de caracteres. Aqui a
 * caixa começa com `rows` linhas, cresce até ALTURA_MAXIMA e mostra quantos
 * caracteres já foram escritos, para deixar claro que dá para continuar.
 */
function CaixaDeTextoLonga({ value, darkMode, rows = 8, className = '', ...props }) {
  const caixaRef = useRef(null);

  useLayoutEffect(() => {
    const caixa = caixaRef.current;
    if (!caixa) return;
    // Zera a altura antes de medir: sem isso a caixa só cresce e nunca
    // volta a diminuir quando o texto é apagado.
    caixa.style.height = 'auto';
    const altura = Math.min(caixa.scrollHeight + 2, ALTURA_MAXIMA);
    caixa.style.height = `${altura}px`;
    caixa.style.overflowY = caixa.scrollHeight + 2 > ALTURA_MAXIMA ? 'auto' : 'hidden';
  }, [value]);

  const total = (value || '').length;

  return (
    <div>
      <textarea
        ref={caixaRef}
        value={value}
        rows={rows}
        className={`resize-y ${className}`}
        {...props}
      />
      <p className={`mt-1 text-right text-xs ${darkMode ? 'text-slate-500' : 'text-slate-400'}`}>
        {total.toLocaleString('pt-BR')} {total === 1 ? 'caractere' : 'caracteres'} · sem limite
      </p>
    </div>
  );
}

export default CaixaDeTextoLonga;
